<template>
  <div>
    <v-stepper v-model="step" tile>
      <v-stepper-header>
        <v-stepper-step editable :step="1">
          Reverse Mortgage Plan
        </v-stepper-step>
        <v-divider />
        <v-stepper-step editable :step="2">
          Summary
        </v-stepper-step>
        <v-divider />
        <v-stepper-step editable :step="3">
          Next Steps
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <div class="d-flex justify-space-between mb-8">
            <div></div>
            <v-btn color="primary" @click="nextStep()"> Next </v-btn>
          </div>
          <div class="ma-2 flex1 mx-auto" style="max-width: 1100px;">

            <!-- <FixedRateRMSense /> -->
            <v-card class="mx-auto mb-8 pa-4 d-flex flex-column justify-start align-center" elevation="3">
              <CustomScenarioChart :period="otherValues.lifeExpectancy" category="age" />
            </v-card>
            <EstimatedCashFlowSavings />
            <EquityChange />

          </div>
        </v-stepper-content>

        <v-stepper-content :step="2">
          <div class="d-flex justify-space-between mb-8">
            <v-btn @click="backStep()"> Back </v-btn>
            <v-btn color="primary" @click="nextStep()"> Next </v-btn>
          </div>
          <Summary />
        </v-stepper-content>

        <v-stepper-content :step="3">
          <div class="d-flex justify-space-between mb-8">
            <v-btn @click="backStep()"> Back </v-btn>
            <div></div>
          </div>
          <LeadCapture />
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import CustomScenarioChart from '../Charts/CustomScenarioChart.vue';
// import FixedRateRMSense from './FixedRateRMSense.vue';
import EstimatedCashFlowSavings from './EstimatedCashFlowSavings.vue';
import EquityChange from './EquityChange.vue';
import LeadCapture from '../../views/LeadCapture/index.vue';
import Summary from '../Summary/index.vue';

export default {
  data: () => ({
    step: 1,
    maxStep: 3,
  }),
  components: {
    CustomScenarioChart,
    EstimatedCashFlowSavings,
    EquityChange,
    Summary,
    LeadCapture
  },
  methods: {
    nextStep() {
      if (this.step < this.maxStep) this.step++;
    },
    backStep() {
      if (this.step > 1) this.step--;
    },
  },
  computed: {
    otherValues() {
      return this.$store.state.scenarioData.currentScenarioData.finalValues.otherValues;
    }
  }
}

</script>

<style></style>
